import { h } from '../components/dom';

const HOVERABLE = 'a, button, input, textarea, label, .s-stack__word, .s-work-row';

export function setupCursor() {
  // Strict desktop-mouse-only: skip if no hover, if any pointer is coarse,
  // or if touch is available. Hybrid laptops with touchscreens count as
  // "mobile-ish" for cursor purposes — feels tacky there.
  if (!matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  if (matchMedia('(any-pointer: coarse)').matches) return;
  if ('ontouchstart' in window || navigator.maxTouchPoints > 0) return;

  const cursor = h('div', { class: 'fx-cursor' },
    h('div', { class: 'fx-cursor__ring' }),
    h('div', { class: 'fx-cursor__dot' }),
  );
  document.body.appendChild(cursor);

  let tx = -100, ty = -100;
  let x = -100, y = -100;

  window.addEventListener('mousemove', (e) => { tx = e.clientX; ty = e.clientY; });
  window.addEventListener('mousedown', () => cursor.classList.add('is-press'));
  window.addEventListener('mouseup',   () => cursor.classList.remove('is-press'));
  document.addEventListener('mouseleave', () => { tx = -100; ty = -100; });

  document.addEventListener('mouseover', (e) => {
    const target = e.target as Element | null;
    if (target?.closest(HOVERABLE)) cursor.classList.add('is-hover');
  });
  document.addEventListener('mouseout', (e) => {
    const target = e.target as Element | null;
    const related = (e as MouseEvent).relatedTarget as Element | null;
    if (target?.closest(HOVERABLE) && !related?.closest?.(HOVERABLE)) {
      cursor.classList.remove('is-hover');
    }
  });

  const tick = () => {
    x += (tx - x) * 0.22;
    y += (ty - y) * 0.22;
    cursor.style.transform = `translate3d(${x}px, ${y}px, 0)`;
    requestAnimationFrame(tick);
  };
  tick();
}
